import absfunny from "../assets/images/absfunny.jpg";
import absfunny2 from "../assets/images/absfunny2.jpg"
import absfunny3 from "../assets/images/absfunny3.jpg";

export const articles = [
  {
    id: 1,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },
  {
    id: 2,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny2,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },
  {
    id: 3,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny3,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },
  {
    id: 4,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },
  {
    id: 5,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny2,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },
  {
    id: 6,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny3,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },{
    id: 7,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },
  {
    id: 8,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny2,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },
  {
    id: 9,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny3,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },{
    id: 10,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },
  {
    id: 11,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny2,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },
  {
    id: 13,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny3,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },{
    id: 14,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },
  {
    id: 15,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny2,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },
  {
    id: 16,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny3,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },{
    id: 17,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },
  {
    id: 18,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny2,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },
  {
    id: 19,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny3,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },{
    id: 20,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },
  {
    id: 21,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny2,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },
  {
    id: 22,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny3,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },{
    id: 23,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },
  {
    id: 24,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny2,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },
  {
    id: 25,
    title: "How to face big decisions4",
    author: "TOM HEART 1",
    image: absfunny3,
    category: "Exclusive",
    likes: 9882198,
    tags: ["reactx", "mern", "naruto", "jiraya", "sonen"],
    about:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit.Reiciendis illum cum est explicabo voluptatem! Fuga facilis, hic sapiente suscipit praesentium architecto quo error, voluptate ducimus deserunt similique dolore iste expedita.",
  },
];
